module.exports = __webpack_public_path__ + "static/botonCuentamelo-ad7af6016cc65214656894d3bd433702.png";